export function sortResourcesByOrden(resources = []) {
  return [...resources].sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
}

export function resourcesToSortedUrls(resources = []) {
  return sortResourcesByOrden(resources)
    .map(resource => resource.url)
    .filter(Boolean);
}
